module.exports = __webpack_public_path__ + "c682e49d02f473e324929ab3ae8d361e.jpg";